import { render, staticRenderFns } from "./companywisereport.vue?vue&type=template&id=6adfa490&scoped=true&"
import script from "./companywisereport.vue?vue&type=script&lang=js&"
export * from "./companywisereport.vue?vue&type=script&lang=js&"
import style0 from "./companywisereport.vue?vue&type=style&index=0&id=6adfa490&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adfa490",
  null
  
)

export default component.exports